import React, { useState } from 'react';
import SyncIcon from '@material-ui/icons/Sync';
import { RightContainer, Row, Title, EditBtn } from '../AMSSync.styled';
import {
  Container,
  Text,
  BubbleContainer,
  Bubble,
} from './SyncSettings.styled';
import EditSyncSettingsDrawer from '../EditSyncSettingsDrawer';

const SyncSettings = ({ userPrivileges, organization, orgTypes }) => {
  const [isEditSyncSettingsDrawerVisible, setEditSyncSettingsDrawerVisibility] =
    useState(false);

  const ramcoTypeId = orgTypes?.find(orgType => orgType.name === 'ramco')?.id;
  const isRamcoOrg = organization?.orgType === ramcoTypeId;
  const gzTypeId = orgTypes?.find(orgType => orgType.name === 'gz')?.id;
  const isGZOrg = organization?.orgType === gzTypeId;

  return (
    <RightContainer>
      <Row>
        <Title>
          <SyncIcon size="small" />
          Sync Settings
        </Title>
        {userPrivileges.isSU && (
          <EditBtn
            onClick={() => {
              setEditSyncSettingsDrawerVisibility(
                !isEditSyncSettingsDrawerVisible
              );
            }}
          >
            Edit
          </EditBtn>
        )}
      </Row>
      <br />
      {organization?.assocStatus?.length ? (
        <Container>
          <Text>Synced Statuses:</Text>
          <BubbleContainer>
            {organization.assocStatus.map(assocStatus => (
              <Bubble key={assocStatus}>{assocStatus}</Bubble>
            ))}
          </BubbleContainer>
        </Container>
      ) : (
        ''
      )}
      {organization?.memberships?.length ? (
        <Container>
          <Text>Synced Memberships:</Text>
          <BubbleContainer>
            {organization.memberships.map(mship => (
              <Bubble key={mship.amsId}>{mship.name}</Bubble>
            ))}
          </BubbleContainer>
        </Container>
      ) : (
        ''
      )}
      {isRamcoOrg && organization?.stateMemberships?.length ? (
        <Container>
          <Text>State Memberships:</Text>
          <BubbleContainer>
            {organization.stateMemberships.map(mship => (
              <Bubble key={mship.amsId}>{mship.name}</Bubble>
            ))}
          </BubbleContainer>
        </Container>
      ) : (
        ''
      )}
      {organization?.excludingBillTypes?.length ? (
        <Container>
          <Text>Excluded Subtypes:</Text>
          <BubbleContainer>
            {organization.excludingBillTypes.map(billType => (
              <Bubble key={billType}>{billType}</Bubble>
            ))}
          </BubbleContainer>
        </Container>
      ) : (
        ''
      )}
      {organization?.phoneType ? (
        <Container>
          <Text>Synced Phone Field:</Text>
          <Bubble>{organization.phoneType}</Bubble>
        </Container>
      ) : (
        ''
      )}
      {isGZOrg && organization?.gzSyncConfig?.syncOnlyActiveContacts ? (
        <Container>
          <Text>Active Only Contacts:</Text>
          <Bubble>Enabled</Bubble>
        </Container>
      ) : (
        ''
      )}
      {isGZOrg && organization?.gzSyncConfig?.allowNotOwnedMemberships ? (
        <Container>
          <Text>Allow not-owned contact memberships:</Text>
          <Bubble>Enabled</Bubble>
        </Container>
      ) : (
        ''
      )}
      {isEditSyncSettingsDrawerVisible && (
        <EditSyncSettingsDrawer
          selectedOrg={organization}
          isEditSyncSettingsDrawerVisible={isEditSyncSettingsDrawerVisible}
          setEditSyncSettingsDrawerVisibility={
            setEditSyncSettingsDrawerVisibility
          }
          orgTypes={orgTypes}
        />
      )}
    </RightContainer>
  );
};

export default SyncSettings;
